var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M20 7h66c5.51915024 0 10 4.48084976 10 10v66c0 5.51915024-4.48084976 10-10 10H20c-5.51915024 0-10-4.48084976-10-10V17c0-5.51915024 4.48084976-10 10-10z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8,
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 9.036
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.12 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    fillRule: "evenodd",
    d: "M74.05377197 38.90820313c-.2769165-.16357422-.6192627-.16992188-.90179443-.01660157l-9.86602783 5.36816407V41.0390625c-.00286866-2.50585938-2.04052735-4.53613281-4.55511475-4.5390625H36.05511475c-2.5145874.00292969-4.5522461 2.03320313-4.55511475 4.5390625v17.921875c.00286865 2.50585938 2.04052734 4.53613281 4.55511475 4.5390625h22.67572021c2.5145874-.00292969 4.5522461-2.03320313 4.55511475-4.5390625v-3.16259766l9.86639404 5.36816407c.28216553.15380859.62487793.14746093.90142822-.015625.27685547-.1640625.44622803-.4609375.44622803-.78125V39.68847656c0-.3203125-.16973877-.61669922-.44622803-.78027343zM61.4631958 58.9609375c-.0014038 1.50390625-1.22418213 2.72167969-2.73303223 2.72363281H36.05505371c-1.5088501-.00195312-2.7312622-1.21972656-2.73303223-2.72363281v-17.921875c.00177002-1.50341797 1.22418213-2.72167969 2.73303223-2.72363281h22.67578125c1.50854492.00195312 2.7312622 1.22021484 2.73309326 2.72363281l-.00073242 17.921875zm1.8227539-5.23095703l9.39202882 5.10986328V41.21875l-9.39202881 5.109375v7.40185547z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "rgb(62,135,168)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "rgb(255,255,255)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    xlinkHref: "#path-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.93592be1c68a50179b08fd51c0072f1f.svg";
export { ForwardRef as ReactComponent };